import { render, staticRenderFns } from "./HomefitStoryV2.vue?vue&type=template&id=3bb278b8&scoped=true&"
import script from "./HomefitStoryV2.vue?vue&type=script&lang=js&"
export * from "./HomefitStoryV2.vue?vue&type=script&lang=js&"
import style0 from "./HomefitStoryV2.vue?vue&type=style&index=0&id=3bb278b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb278b8",
  null
  
)

export default component.exports